var SelectModule = require('../modules/select')

let Module = {
    name: 'state',
    selectors: {
        input: '#stateInput',
        wrapper: '.state-wrapper',
        select2: '#stateInput'
    },

    init: function () {
        if ($(Module.selectors.input).length === 0) {
            return;
        }
        $(document).on('countries:init', function (e) {
            Module.setStateInput(Module.selectors.wrapper, e.countryData);
        })

        $(document).on('countries:changed', function (e) {
            Module.setStateInput(Module.selectors.wrapper, e.countryData);
        })
    },

    setStateInput: function (selectorWrapper, countryData) {
        let selectParent = $(Module.selectors.select2).closest('.ct-form-item');
        let selectedState = $(Module.selectors.input).data('state');
        let selectedStateName = $(Module.selectors.input).data('statename');
        let oldValue = $(Module.selectors.input).data('old-value');
        let placeholder = $(Module.selectors.input).data('placeholder');
        let selectedOption = '';

        if (countryData.states_count > 0) {
            if (selectedState) {
                selectedOption = "<option value='" + selectedState + "' selected='selected'>" + selectedStateName + "</option>";
            }

            var input;
            if (placeholder) {
                input = $("<select class='saveCookie no-search' data-placeholder='"+ placeholder +"' name='state_id' id='stateInput'>" + selectedOption + "</select>")
            } else {
                input = $("<select class='saveCookie no-search' data-placeholder='' name='state_id' id='stateInput'>" + selectedOption + "</select>")
            }
            input.data('old-value', oldValue);
            if($(Module.selectors.input).hasClass('saveCookie')) {
                input.addClass('saveCookie');
            }
            if($(Module.selectors.input).hasClass('loadCookie')) {
                input.addClass('loadCookie');
            }
            $(selectorWrapper).empty().append(input).closest('.ct-red-text').show();
            $('.ct-red-text', $(selectorWrapper).parent()).show();
            SelectModule.init(input, allStates[countryData.id]).on('select2:select', function (e) {});
        } else {
            let selectedStateName = $(Module.selectors.input).data('statename');
            if (selectedStateName === null || selectedStateName === undefined) {
                selectedStateName = '';
            }
            var input = $("<input class='' data-placeholder='"+ placeholder +"' placeholder='State' type='text' name='state_name' value='" + selectedStateName + "' id='stateInput'>");
            input.data('old-value', oldValue);

            if ($(Module.selectors.input).hasClass('saveCookie')){
                input.addClass('saveCookie');
            }
            if ($(Module.selectors.input).hasClass('loadCookie')){
                input.addClass('loadCookie');
            }

            $(selectorWrapper).empty().append(input);
            selectParent.removeClass('has-error');
            $('.ct-red-text', $(selectorWrapper).parent()).hide();
        }

        input.closest('.cmt-form-item.lh-float-label').removeClass('lh-float-label-active');
        $(Module.selectors.input).trigger('change');
    },
}

module.exports = Module
